/**
 * PARTS OF ONE WHOLE, with each part's count printed beside its colour.
 *
 * The legend is the data; the bar is its picture. Parts are separate facts
 * (confirmed, needs attention, not reviewed) — never a percentage, and never a
 * part that means "not flagged" drawn in the colour of "confirmed".
 */
export interface Segment {
  readonly id: string;
  readonly label: string;
  readonly value: number;
  readonly tone: 'ok' | 'warn' | 'danger' | 'ink' | 'muted' | 'outdated';
}

export function SegmentBar({ segments, label, testId }: { segments: readonly Segment[]; label: string; testId?: string }) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);

  return (
    <div className="ui-segbar" data-testid={testId}>
      <div className="ui-segbar-track" role="img" aria-label={label}>
        {total === 0
          ? null
          : segments.map((s) =>
              s.value === 0 ? null : (
                <span key={s.id} data-tone={s.tone} style={{ width: `${String((s.value / total) * 100)}%` }} />
              ),
            )}
      </div>
      <ul className="ui-segbar-legend">
        {segments.map((s) => (
          <li key={s.id} data-testid={testId === undefined ? undefined : `${testId}-${s.id}`}>
            <span className="ui-segbar-key" data-tone={s.tone} aria-hidden="true" />
            <strong>{String(s.value)}</strong> {s.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
